/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { FarmTotal, FarmTotalFromJSON, FarmTotalFromJSONTyped, FarmTotalToJSON } from './FarmTotal'

/**
 *
 * @export
 * @interface BonusBalances
 */
export interface BonusBalances {
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  cashback?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  referralFarming?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  teamFarming?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  referralTrading?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  teamTrading?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  holderBonus?: number
  /**
   *
   * @type {number}
   * @memberof BonusBalances
   */
  total?: number
  /**
   *
   * @type {Array<FarmTotal>}
   * @memberof BonusBalances
   */
  farms?: Array<FarmTotal>
}

export function BonusBalancesFromJSON(json: any): BonusBalances {
  return BonusBalancesFromJSONTyped(json, false)
}

export function BonusBalancesFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusBalances {
  if (json === undefined || json === null) {
    return json
  }
  return {
    cashback: !exists(json, 'cashback') ? undefined : json['cashback'],
    referralFarming: !exists(json, 'referralFarming') ? undefined : json['referralFarming'],
    teamFarming: !exists(json, 'teamFarming') ? undefined : json['teamFarming'],
    referralTrading: !exists(json, 'referralTrading') ? undefined : json['referralTrading'],
    teamTrading: !exists(json, 'teamTrading') ? undefined : json['teamTrading'],
    holderBonus: !exists(json, 'holderBonus') ? undefined : json['holderBonus'],
    total: !exists(json, 'total') ? undefined : json['total'],
    farms: !exists(json, 'farms') ? undefined : (json['farms'] as Array<any>).map(FarmTotalFromJSON),
  }
}

export function BonusBalancesToJSON(value?: BonusBalances | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    cashback: value.cashback,
    referralFarming: value.referralFarming,
    teamFarming: value.teamFarming,
    referralTrading: value.referralTrading,
    teamTrading: value.teamTrading,
    holderBonus: value.holderBonus,
    total: value.total,
    farms: value.farms === undefined ? undefined : (value.farms as Array<any>).map(FarmTotalToJSON),
  }
}
